import '../../styles/List.css'


export default function List({titleOne, titleTwo, titleThree ,titleFour, titleFive}) {

    return (
        <div>
            <ul className="inline-list">
                <li className='teste'>{titleOne}</li>
                <li>{titleTwo}</li>
                <li>{titleThree}</li>
                <li>{titleFour}</li>
                <li>{titleFive}</li>
            </ul>
        </div>
    )

}